define([
    'react',
    'lodash'
], function (React, _) {
    'use strict';
    return function () {
        return React.createElement('input', {
            'type': 'text',
            'className': this.getClass(),
            'defaultValue': this.state.value,
            'onKeyUp': this.props.onKeyUp,
            'onChange': this.handleChange,
            'placeholder': this.props.placeholder,
            'disabled': this.props.disabled,
            'tabIndex': this.props.tabIndex,
            'autoFocus': this.props.autoFocus,
            'onBlur': this.props.onBlur
        });
    };
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/form-controls/inputs/text-input/text-input.rt
 ** module id = 166
 ** module chunks = 0
 **/